import * as React from 'react';
import { Rule, RulesMessages } from '../utils/validator';
import { HatType } from './Hat';
import MaskedInput from './MaskedInput';

interface PasswordInputProps {
  placeHolder?: string;
  name: string;
  value?: string;
  id: string;
  label: string;
  required?: boolean;
  focus?: boolean;
  hasError?: boolean;
  errors?: any;
  maxLength?: number;
  minLength?: number;
  theme?: 'night' | 'day';
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  allowRegex?: any;
  onChange?: Function;
  onComplete?: Function;
  onError?: Function;
  onBlur?: Function;
  onEsc?: Function;
  onEnter?: Function;
  onLeft?: Function;
  onRight?: Function;
  onUp?: Function;
  onDown?: Function;
  onSpace?: Function;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  autocomplete?: string;
}

export default function PasswordInput(props: PasswordInputProps) {
  const componentPropsRules: Rule[] = [];

  const { minLength = 8, maxLength = 128 } = props;

  componentPropsRules.push({
    ruleName: 'password',
    message: props.rulesMessages && props.rulesMessages.password,
    defaultMessage: `${props.label} should contain at least one uppercase letter, one lowercase letter, one number and one special character.`,

    dependsOn: ['minLength']
  });

  if (props.validationRules) {
    componentPropsRules.push(...props.validationRules);
  }

  return (
    <MaskedInput
      placeHolder={props.placeHolder}
      name={props.name}
      value={props.value}
      id={props.id}
      label={props.label}
      required={props.required}
      focus={props.focus}
      hasError={props.hasError}
      errors={props.errors}
      maxLength={maxLength}
      minLength={minLength}
      theme={props.theme}
      validationRules={componentPropsRules}
      allowRegex={props.allowRegex}
      onComplete={props.onComplete}
      onChange={props.onChange}
      onError={props.onError}
      onBlur={props.onBlur}
      onEsc={(inputValue: string) => {
        if (props.onEsc !== undefined) {
          props.onEsc(inputValue);
        }
      }}
      onEnter={(inputValue: string) => {
        if (props.onEnter !== undefined) {
          props.onEnter(inputValue);
        }
      }}
      onUp={(inputValue: string) => {
        if (props.onUp !== undefined) {
          props.onUp(inputValue);
        }
      }}
      onDown={(inputValue: string) => {
        if (props.onDown !== undefined) {
          props.onDown(inputValue);
        }
      }}
      onLeft={(inputValue: string) => {
        if (props.onLeft !== undefined) {
          props.onLeft(inputValue);
        }
      }}
      onRight={(inputValue: string) => {
        if (props.onRight !== undefined) {
          props.onRight(inputValue);
        }
      }}
      onSpace={(inputValue: string) => {
        if (props.onSpace !== undefined) {
          props.onSpace(inputValue);
        }
      }}
      hat={props.hat}
      readOnly={props.readOnly}
      disabled={props.disabled}
      autocomplete={props.autocomplete}
    />
  );
}
